module.exports = __webpack_public_path__ + "img/2-1_03.7ee79d35.jpg";